<template>
  <div>
    <form>
      <label
        >{{ this.field.metadata.label }}
        <span class="required" v-if="this.field.metadata.required">*</span>
      </label>
      <br />
      <div
        class="option"
        v-for="(option, index) in this.field.metadata.options"
        :key="index"
      >
        <input
          :type="field.metadata.optionType"
          :value="option.value"
          :name="field.metadata.fieldName"
          @change="updateDependency()"
          :id="getID(index)"
          :data-nextOptionID="(count+1+index)"
        />
        <label :for="getID(index)">{{ option.label }}</label>
      </div>
    </form>
    <div class="hint" v-if="this.field.metadata.hint">
      <span v-html="this.field.metadata.hint"></span>
    </div>
  </div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "FormOptionGroup",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      count: 0,
    };
  },
  beforeMount() {
    const checkboxes = document.querySelectorAll("input[data-nextOptionID]");
    if (checkboxes.length <= 0) {
      this.count = 1;
    } else {
      this.count = parseInt(checkboxes[checkboxes.length-1].dataset.nextoptionid);
    }
  },
  methods: {
    updateDependency: function () {
      Bus.$emit("checkDependency");
    },
    getID: function(index) {
      const ID_PREFIX = "form-option";
      return `${ID_PREFIX}-${this.count+index}`
    }
  },
  beforeDestroy() {
    // might be the parent of other component, so emit the event again to hide the component
    Bus.$emit("checkDependency");
  },
};
</script>

<style scoped>
.option {
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
}

.hint {
  color: #8a8a8a;
  margin-top: 5px;
}

.hint >>> * {
  margin-top: 0;
  margin-bottom: 0;
}

.required {
  color: #f00;
}
</style>